import { makeStyles } from '@material-ui/core/styles';
import { EntitySoxFilter, CustomFilters } from '../CustomFilters';
import { useEntityList } from '@backstage/plugin-catalog-react';
import { Select, MenuItem, FormControl } from '@material-ui/core';

/** @public */
export type CatalogReactEntitySoxPickerClassKey = 'input';

const useStyles = makeStyles(
  theme => ({
    input: {
      backgroundColor: theme.palette.background.paper,
    },
  }),
  { name: 'CatalogReactEntitySoxPicker' },
);

/** @public */
export const EntitySoxPicker = () => {
  const classes = useStyles();

  const {
    filters: { sox },
    updateFilters,
  } = useEntityList<CustomFilters>();

  function onChange(event: React.ChangeEvent<{ value: unknown }>) {
    const value = event.target.value as string;
    updateFilters({
      sox: value ? new EntitySoxFilter([value]) : undefined,
    });
  }

  const selectedValue = sox?.values?.[0] || '';

  return (
    <div>
      <label
        style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px' }}
        htmlFor="sox-picker"
      >
        SOX
      </label>
      <FormControl
        variant="outlined"
        size="small"
        fullWidth
        className={classes.input}
        id="sox-picker"
      >
        <Select value={selectedValue} onChange={onChange}>
          <MenuItem value="">
            <em>All</em>
          </MenuItem>
          <MenuItem value="true">Yes</MenuItem>
          <MenuItem value="false">No</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};
